/* HealthSpot: menu badges, header Compare/Wishlist icons, card + product buttons.
   Lists are stored in the shopper's own browser (localStorage) as [{h: handle, i: productId}]. */
(function () {
  var CFG = window.hsConfig || { badges: [], compare: true, wish: true };
  var KEYS = { wish: 'hs-wishlist', compare: 'hs-compare' };
  var MAX_COMPARE = 4;
  var ICON = {
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path class="hs-heart" d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>',
    compare: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7 4 3 8l4 4"/><path d="M3 8h14"/><path d="m17 20 4-4-4-4"/><path d="M21 16H7"/></svg>'
  };

  function get(k) { try { var a = JSON.parse(localStorage.getItem(KEYS[k]) || '[]'); return a.filter(function (x) { return x && x.h; }); } catch (e) { return []; } }
  function set(k, v) { try { localStorage.setItem(KEYS[k], JSON.stringify(v)); } catch (e) {} }
  function has(k, h) { return get(k).some(function (x) { return x.h === h; }); }

  function toast(msg) {
    var t = document.getElementById('hs-toast');
    if (!t) { t = document.createElement('div'); t.id = 'hs-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }

  function lookupId(h, known) {
    if (known) return Promise.resolve(Number(known));
    return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.json(); }).then(function (p) { return p.id; });
  }

  function toggle(k, h, knownId) {
    var a = get(k);
    var idx = a.findIndex(function (x) { return x.h === h; });
    if (idx > -1) {
      a.splice(idx, 1); set(k, a); refresh();
      toast(k === 'wish' ? 'Removed from wishlist' : 'Removed from compare');
      if (onPage(k)) location.reload();
      return;
    }
    if (k === 'compare' && a.length >= MAX_COMPARE) { toast('You can compare up to ' + MAX_COMPARE + ' products'); return; }
    lookupId(h, knownId).then(function (id) {
      var b = get(k);
      if (b.some(function (x) { return x.h === h; })) { refresh(); return; } /* double-click guard: never add the same product twice */
      if (k === 'compare' && b.length >= MAX_COMPARE) { toast('You can compare up to ' + MAX_COMPARE + ' products'); return; }
      b.push({ h: h, i: id }); set(k, b); refresh();
      toast(k === 'wish' ? 'Saved to wishlist' : 'Added to compare (' + b.length + '/' + MAX_COMPARE + ')');
    }).catch(function () { toast('Something went wrong. Please try again.'); });
  }
  function onPage(k) { return location.pathname.replace(/\/$/, '') === (k === 'wish' ? '/pages/wishlist' : '/pages/compare'); }

  function btn(cls, k, h, label) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = cls; b.setAttribute('data-hs-' + k, h); b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', label); b.title = label; b.innerHTML = ICON[k === 'wish' ? 'heart' : 'compare'];
    return b;
  }

  function decorateCards(root) {
    (root || document).querySelectorAll('.product-card[data-product-handle] .card__inner').forEach(function (inner) {
      if (inner.querySelector('.hs-card-actions')) return;
      var h = inner.closest('[data-product-handle]').getAttribute('data-product-handle');
      var wrap = document.createElement('div'); wrap.className = 'hs-card-actions';
      if (CFG.wish) wrap.appendChild(btn('hs-iconbtn', 'wish', h, 'Add to wishlist'));
      if (CFG.compare) wrap.appendChild(btn('hs-iconbtn', 'compare', h, 'Compare'));
      inner.appendChild(wrap);
    });
  }

  /* Header icons in the order Account, Compare, Wishlist, Cart. Pharmily-style: round icon with two lines of text beside it
     (e.g. "Account / Login / Register", "Wishlist / 0"). Idempotent and only writes when text changes,
     because the theme re-renders the cart icon after every add-to-cart and a MutationObserver re-runs this. */
  function setText(el, v) { v = String(v); if (el.textContent !== v) el.textContent = v; }
  function decorateIcon(el, t1, t2, countKey) {
    if (!el) return;
    el.classList.add('hs-hicon');
    var circle = el.querySelector(':scope > .hs-hicon__circle');
    if (!circle) {
      circle = document.createElement('span'); circle.className = 'hs-hicon__circle'; circle.setAttribute('aria-hidden', 'true');
      el.insertBefore(circle, el.firstChild);
    }
    Array.prototype.slice.call(el.children).forEach(function (c) {
      if (c === circle) return;
      if (c.matches('svg, account-icon, img, .cart-count-bubble, .hs-hicon__count')) circle.appendChild(c);
    });
    var lab = el.querySelector(':scope > .hs-hicon__label');
    if (!lab) {
      lab = document.createElement('span'); lab.className = 'hs-hicon__label'; lab.setAttribute('aria-hidden', 'true');
      lab.innerHTML = '<span class="hs-hicon__t1"></span><span class="hs-hicon__t2"' + (countKey ? ' data-hs-count-text="' + countKey + '"' : '') + '></span>';
      el.appendChild(lab);
    }
    setText(lab.firstChild, t1);
    if (t2 !== null) setText(lab.lastChild, t2);
  }

  function decorateHeader() {
    var icons = document.querySelector('.header__icons');
    if (icons) {
      icons.classList.add('hs-hicons');
      var cart = icons.querySelector('.header__icon--cart');
      function link(href, k, txt, extra) {
        var a = document.createElement('a'); a.href = href; a.className = 'header__icon link focus-inset ' + (extra || ''); a.setAttribute('aria-label', txt);
        a.innerHTML = ICON[k === 'wish' ? 'heart' : 'compare'] + '<span class="hs-hicon__count" data-hs-count="' + k + '" hidden>0</span>';
        return a;
      }
      if (CFG.compare && cart && !icons.querySelector('.hs-hicon--compare')) cart.parentNode.insertBefore(link('/pages/compare', 'compare', 'Compare', 'small-hide hs-hicon--compare'), cart);
      if (CFG.wish && cart && !icons.querySelector('.hs-hicon--wish')) cart.parentNode.insertBefore(link('/pages/wishlist', 'wish', 'Wishlist', 'hs-hicon--wish'), cart);
      var acct = CFG.acct || {};
      decorateIcon(icons.querySelector('.header__icon--account'), acct.signedIn ? (acct.name ? 'Hi, ' + acct.name : 'Account') : 'Account', acct.signedIn ? 'My account' : 'Login / Register');
      decorateIcon(icons.querySelector('.hs-hicon--compare'), 'Compare', null, 'compare');
      decorateIcon(icons.querySelector('.hs-hicon--wish'), 'Wishlist', null, 'wish');
      var bubble = cart && cart.querySelector('.cart-count-bubble span[aria-hidden]');
      decorateIcon(cart, 'Cart', bubble ? bubble.textContent.trim() : '0');
    }
    /* Brands dropdown: swap the plain list for logo tiles */
    var btpl = document.getElementById('hs-brands-tpl');
    if (btpl) {
      document.querySelectorAll('.list-menu--inline > li').forEach(function (li) {
        var sum = li.querySelector(':scope details > summary');
        var ul = li.querySelector(':scope details > .header__submenu');
        if (!sum || !ul || ul.classList.contains('hs-brandmenu')) return;
        if (sum.textContent.trim().toLowerCase() !== 'brands') return;
        ul.classList.add('hs-brandmenu');
        ul.innerHTML = '';
        ul.appendChild(btpl.content.cloneNode(true));
      });
    }
    /* "Submit a Prescription" on the right of the desktop menu row */
    var rtpl = document.getElementById('hs-rx-tpl');
    var row = document.querySelector('.header__inline-menu > .page-width');
    if (rtpl && row && !row.querySelector('.hs-rxbtn')) { row.classList.add('hs-navrow'); row.appendChild(rtpl.content.cloneNode(true)); }
    /* HealthSpot (2026-10-24): a second copy sits in the top icon row. CSS shows it instead of the menu-row button
       on 990-1279px screens (so the menu fits on one line) and as a compact icon on phones and tablets. */
    var icons2 = document.querySelector('.header__icons');
    if (rtpl && icons2 && !icons2.querySelector('.hs-rxbtn--top')) {
      var frag = rtpl.content.cloneNode(true), ra = frag.querySelector('a');
      if (ra) {
        ra.classList.add('hs-rxbtn--top'); ra.setAttribute('aria-label', ra.textContent.trim()); ra.setAttribute('data-hs-label', 'header-top');
        var sp = ra.querySelector('span'); if (sp) sp.setAttribute('data-short', 'Prescription');
        icons2.insertBefore(frag, icons2.firstElementChild);
      }
    }
    (CFG.hide || []).forEach(function (u) {
      document.querySelectorAll('.list-menu--inline > li, [class*="menu-drawer"] li').forEach(function (li) {
        /* only simple items (no sub-menu) whose first link points at the empty collection */
        var a = li.querySelector('a');
        if (a && a.getAttribute('href') === u && !li.querySelector('ul, details')) li.style.display = 'none';
      });
    });
    (CFG.badges || []).forEach(function (b) {
      if (!b.link || !b.text) return;
      document.querySelectorAll('.list-menu--inline > li').forEach(function (li) {
        if (li.querySelector('.hs-badge')) return;
        var a = li.querySelector('a, summary');
        if (a && a.textContent.trim().toLowerCase() === b.link.trim().toLowerCase()) {
          var s = document.createElement('span'); s.className = 'hs-badge'; s.textContent = b.text; s.style.setProperty('--hs-badge', b.color || '#e02424');
          li.appendChild(s);
        }
      });
      /* Same badge, shown inline in the mobile/desktop drawer menu */
      document.querySelectorAll('[class*="menu-drawer"] a, [class*="menu-drawer"] summary').forEach(function (a) {
        if (a.querySelector('.hs-badge')) return;
        var t = a.textContent.trim().toLowerCase();
        if (t === b.link.trim().toLowerCase()) {
          var s = document.createElement('span'); s.className = 'hs-badge hs-badge--inline'; s.textContent = b.text; s.style.setProperty('--hs-badge', b.color || '#e02424');
          a.appendChild(s);
        }
      });
    });
  }

  function refresh() {
    ['wish', 'compare'].forEach(function (k) {
      var a = get(k);
      document.querySelectorAll('[data-hs-count="' + k + '"]').forEach(function (el) { setText(el, a.length); if (el.hidden !== !a.length) el.hidden = !a.length; });
      document.querySelectorAll('[data-hs-count-text="' + k + '"]').forEach(function (el) { setText(el, a.length); });
      document.querySelectorAll('[data-hs-' + k + ']').forEach(function (b) {
        var on = a.some(function (x) { return x.h === b.getAttribute('data-hs-' + k); });
        if (b.classList.contains('is-active') !== on) b.classList.toggle('is-active', on);
        if (b.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var l = b.querySelector('[data-hs-label]'); if (l && b.dataset.on) setText(l, on ? b.dataset.on : b.dataset.off);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hs-wish],[data-hs-compare],[data-hs-clear]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.hasAttribute('data-hs-clear')) { set(b.getAttribute('data-hs-clear'), []); location.reload(); return; }
    if (b.hasAttribute('data-hs-wish')) toggle('wish', b.getAttribute('data-hs-wish'), b.dataset.hsId);
    else toggle('compare', b.getAttribute('data-hs-compare'), b.dataset.hsId);
  }, true);

  /* HealthSpot (2026-10-24): on the compare page, "Headline | detail" key benefits become a readable list */
  function tidyCompare() {
    if (!onPage('compare')) return;
    document.querySelectorAll('.metafield-csv-lists li:not([data-hs-kb])').forEach(function (li) {
      li.setAttribute('data-hs-kb', '1');
      var t = li.textContent, i = t.indexOf(' | ');
      if (i < 1) return;
      li.textContent = '';
      var b = document.createElement('strong'); b.textContent = t.slice(0, i).trim();
      li.appendChild(b); li.appendChild(document.createTextNode(' – ' + t.slice(i + 3).trim()));
      if (li.parentNode) li.parentNode.classList.add('hs-kb-list');
    });
  }
  function run() { decorateHeader(); decorateCards(); refresh(); tidyCompare(); }
  window.hsShop = { get: get, set: set, refresh: refresh, run: run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var pending = false;
  new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; decorateCards(); decorateHeader(); refresh(); tidyCompare(); }, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
